import React, { forwardRef } from 'react';

const ResizeIcon = forwardRef<SVGSVGElement, { className?: string }>(({ className }, ref) => {
  return (
    <svg ref={ref} className={className} width='32' height='48' viewBox='0 0 32 48' xmlns='http://www.w3.org/2000/svg'>
      <g fill='none' stroke='#a3a3a3' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
        <line x1='6' y1='8' x2='26' y2='8' />
        <line x1='6' y1='40' x2='26' y2='40' />
        <line x1='16' y1='17' x2='16' y2='31' />
        <polyline points='13,20 16,17 19,20' />
        <polyline points='13,28 16,31 19,28' />
      </g>
    </svg>
  );
});

ResizeIcon.displayName = 'ResizeIcon';

export default ResizeIcon;
